import {fromJS} from 'immutable';
import * as types from 'constants/action-types';
import {
  setRecordsReducer,
  setCurrentRecordPageReducer,
  setCurrentRecordReducer,
  clearRecordsAfterPageReducer,
} from './base';

const initialState = fromJS({
  activatedSubscriptionPages: {
    currentPage: 1,
    totalCount: 0,
    pageCount: 1,
    itemsPerPage: 0,
  },
  currentActivatedSubscription: {},
  pendingSubscriptionPages: {
    currentPage: 1,
    totalCount: 0,
    pageCount: 1,
    itemsPerPage: 0,
  },
  currentPendingSubscription: {},
  classroomSubscriptionPages: {
    currentPage: 1,
    totalCount: 0,
    pageCount: 1,
    itemsPerPage: 0,
  },
  currentClassroomSubscription: {},
});

const setActivatedSubscriptionsReducer = (state, action) => setRecordsReducer('activatedSubscription', state, action);

const setCurrentActivatedSubscriptionPageReducer = (state, action) =>
  setCurrentRecordPageReducer('activatedSubscription', state, action);

const setCurrentActivatedSubscriptionReducer = (state, action) =>
  setCurrentRecordReducer('activatedSubscription', state, action);

const clearActivatedSubscriptionsAfterPageReducer = (state, action) =>
  clearRecordsAfterPageReducer('activatedSubscription', state, action);

const setPendingSubscriptionsReducer = (state, action) => setRecordsReducer('pendingSubscription', state, action);

const setCurrentPendingSubscriptionPageReducer = (state, action) =>
  setCurrentRecordPageReducer('pendingSubscription', state, action);

const setCurrentPendingSubscriptionReducer = (state, action) =>
  setCurrentRecordReducer('pendingSubscription', state, action);

const clearPendingSubscriptionsAfterPageReducer = (state, action) =>
  clearRecordsAfterPageReducer('pendingSubscription', state, action);

const setClassroomSubscriptionsReducer = (state, action) => setRecordsReducer('classroomSubscription', state, action);

const setCurrentClassroomSubscriptionPageReducer = (state, action) =>
  setCurrentRecordPageReducer('classroomSubscription', state, action);

const setCurrentClassroomSubscriptionReducer = (state, action) =>
  setCurrentRecordReducer('classroomSubscription', state, action);

const clearClassroomSubscriptionsAfterPageReducer = (state, action) =>
  clearRecordsAfterPageReducer('classroomSubscription', state, action);

export default (state = initialState, action = {}) => {
  switch (action.type) {
    case types.REINITIALIZE_STORE_STATE:
      return initialState;
    // Activated Subscription
    case types.SET_ACTIVATED_SUBSCRIPTIONS:
      return setActivatedSubscriptionsReducer(state, action);
    case types.SET_CURRENT_ACTIVATED_SUBSCRIPTION_PAGE:
      return setCurrentActivatedSubscriptionPageReducer(state, action);
    case types.SET_CURRENT_ACTIVATED_SUBSCRIPTION:
      return setCurrentActivatedSubscriptionReducer(state, action);
    case types.CLEAR_ACTIVATED_SUBSCRIPTIONS_AFTER_PAGE:
      return clearActivatedSubscriptionsAfterPageReducer(state, action);
    // Pending Subscription
    case types.SET_PENDING_SUBSCRIPTIONS:
      return setPendingSubscriptionsReducer(state, action);
    case types.SET_CURRENT_PENDING_SUBSCRIPTION_PAGE:
      return setCurrentPendingSubscriptionPageReducer(state, action);
    case types.SET_CURRENT_PENDING_SUBSCRIPTION:
      return setCurrentPendingSubscriptionReducer(state, action);
    case types.CLEAR_PENDING_SUBSCRIPTIONS_AFTER_PAGE:
      return clearPendingSubscriptionsAfterPageReducer(state, action);
    // Classroom Subscription
    case types.SET_CLASSROOM_SUBSCRIPTIONS:
      return setClassroomSubscriptionsReducer(state, action);
    case types.SET_CURRENT_CLASSROOM_SUBSCRIPTION_PAGE:
      return setCurrentClassroomSubscriptionPageReducer(state, action);
    case types.SET_CURRENT_CLASSROOM_SUBSCRIPTION:
      return setCurrentClassroomSubscriptionReducer(state, action);
    case types.CLEAR_CLASSROOM_SUBSCRIPTIONS_AFTER_PAGE:
      return clearClassroomSubscriptionsAfterPageReducer(state, action);
    default:
      return state;
  }
};
